export default "__VITE_ASSET__oRiM4qbW__"